import {combineReducers, createStore} from 'redux';
import reducer from './Reducer';
import imageReducer from './ImageReducer';
import socialReducer from './SocialReducer';
import ArabicReducer from './ArabicReducer';
import TranslationReducer from './TranslationReducer';
import TourReducer from './TourReducer';
import LanguageReducer from "./LanguageReducer";

export const store = createStore(combineReducers({reducer, imageReducer, socialReducer, ArabicReducer, TranslationReducer, TourReducer,LanguageReducer}));
